//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export ClientListConfig
export const ClientListConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path: "/app/bankRec/clientList",
      component: FuseLoadable({
        loader: () => import("./EditClients.js")
      })
    }
  ]
  //end routes
};
